import * as actions from './actions';

export const notify = [
  actions.addNotification
];

export const resetNotFound = [
  actions.resetNotFound
];